import { Injectable, Renderer2 } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class HeightRatioService {
  windowResized$ = new Subject();

  // constructor(
  //   private renderer2: Renderer2,
  // ) {
  //   this.renderer2.listen('window', 'resize', () => {
  //     this.windowResized$.next();
  //   });
  // }
}
